module.exports = __webpack_public_path__ + "img/havermoutkoekjes-met-dadels-en-abrikozen.6c09b0d3.jpeg";